import { useState, useCallback } from "react";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const useApi = (url, initialOptions = {}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [options, setOptions] = useState(initialOptions);

  const fetchApi = useCallback(async (method = "GET", payload = null, customOptions = {}) => {
    setLoading(true);
    try {
      const config = {
        method,
        url: `${apiUrl}${url}`,
        ...options,
        ...customOptions,
        data: payload,
      };

      const response = await axios(config);
      setData(response.data);
      setError(null);
      return response.data;
    } catch (err) {
      const errData = err.response ? err.response.data : err.message;
      setData(null);
      setError(errData);
      const onErrorCallback = customOptions.onError || options.onError;
      if (typeof onErrorCallback === 'function') {
        onErrorCallback(errData);
      }
    } finally {
      setLoading(false);
    }
  }, [url, options]);

  return { data, loading, error, refetch: fetchApi, setOptions };
};

export default useApi;